import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import apiClient from '../api/client';

export default function AdvanceFeatureModal({ user, domain, onClose }) {
  const [features, setFeatures] = useState({
    addPatient: false,
    calendar: false,
    officeCalendar: false,
    checklist: false,
    documentManager: false,
    patientNote: false,
    signOnFile: false,
    surgeryForms: false,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchFeatures = async () => {
      setLoading(true);
      try {
        const res = await apiClient.post(`/api/users/advance-features`, {
          domain, userId: user.szUserId, companyId: user.szCompanyId,
        });
        setFeatures(res.data);
      } catch (err) {
        toast.error("Failed to load advance features");
        onClose();
      } finally {
        setLoading(false);
      }
    };
    fetchFeatures();
  }, [user, domain, token, onClose]);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setFeatures(prev => ({ ...prev, [name]: checked }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiClient.post(`/api/users/update-advance-features`, {
        domain, userId: user.szUserId, companyId: user.szCompanyId, features,
      });
      toast.success("Advance features updated successfully!");
      onClose();
    } catch (err) {
      toast.error("Failed to update advance features");
    } finally {
      setSaving(false);
    }
  };

  const formatLabel = (key) =>
    key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

  return (
    <div
      className="modal fade show"
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '420px' }} role="document">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '8px', overflow: 'hidden' }}>

          {/* Header */}
          <div style={{ backgroundColor: '#0aa375', padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ color: 'white', fontWeight: 700, fontSize: '13px' }}>Advance Features</div>
              <div style={{ color: 'white', fontSize: '11px', marginTop: '2px' }}>
                <span>{user.szUserName}</span>
                <span style={{ margin: '0 6px', opacity: 0.5 }}>|</span>
                <span>{user.szCompanyName}</span>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.65)', fontSize: '10px', marginTop: '2px' }}>
                <span>UID: {user.szUserId}</span>
                <span style={{ margin: '0 6px', opacity: 0.5 }}>|</span>
                <span>CID: {user.szCompanyId}</span>
              </div>
            </div>
            <button type="button" className="btn-close btn-close-white" style={{ fontSize: '10px' }} onClick={onClose} />
          </div>

          {/* Body */}
          <div style={{ padding: '14px' }}>
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border spinner-border-sm" style={{ color: '#0aa375' }} role="status" />
                <p className="mt-2 mb-0 text-muted" style={{ fontSize: '12px' }}>Loading features...</p>
              </div>
            ) : (
              <>
                <div style={{ fontSize: '10px', fontWeight: 600, color: '#212529', textTransform: 'uppercase', letterSpacing: '0.3px', borderBottom: '2px solid #0aa375', paddingBottom: '3px', marginBottom: '10px' }}>
                  Feature Access
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 12px' }}>
                  {Object.entries(features).map(([key, value]) => (
                    <label
                      key={key}
                      style={{
                        display: 'flex', alignItems: 'center', gap: '8px',
                        padding: '6px 10px', borderRadius: '5px', cursor: 'pointer',
                        background: value ? '#f0fdf8' : '#f8f9fa',
                        border: `1px solid ${value ? '#a3d9c0' : '#e9ecef'}`,
                        transition: 'all 0.15s',
                        fontSize: '12px', color: '#212529', fontWeight: value ? 600 : 400,
                      }}
                    >
                      <input
                        type="checkbox"
                        name={key}
                        checked={value}
                        onChange={handleChange}
                        disabled={saving}
                        style={{ accentColor: '#0aa375', width: '13px', height: '13px', cursor: 'pointer' }}
                      />
                      {formatLabel(key)}
                    </label>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Footer */}
          <div style={{ padding: '8px 14px', borderTop: '1px solid #e9ecef', display: 'flex', justifyContent: 'center', gap: '8px', background: '#fafafa' }}>
            <button
              className="btn btn-sm btn-outline-secondary"
              style={{ fontSize: '12px', padding: '3px 14px' }}
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              className="btn btn-sm text-white fw-semibold"
              style={{ fontSize: '12px', padding: '3px 16px', backgroundColor: saving ? '#6c757d' : '#0aa375', border: 'none' }}
              onClick={handleSave}
              disabled={loading || saving}
            >
              {saving ? (
                <><span className="spinner-border spinner-border-sm me-1" role="status" />Saving...</>
              ) : 'Update'}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
